import React from 'react';
import styles from './assets/FileSelect.module.css';
import { IoClose, IoPlay, IoSave } from 'react-icons/io5';
import classNames from 'classnames';
import {
  formatAudioFileSize,
  getAudioProgressPercentage,
} from '../../../../utils/audioFiles.utils';

const SelectedFileControl = ({ file, progress, onClear, onPlay, onSave }) => {
  const progressPercentage = getAudioProgressPercentage(progress, 1);
  if (file)
    return (
      <div className="flex-fill align-self-stretch d-flex flex-column justify-content-center align-items-stretch px-5">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="text-truncate small fw-semibold">{file.name}</span>
          <button
            className="btn btn-sm btn-outline-secondary ms-2 flex-shrink-0"
            aria-label="Clear audio file"
            onClick={onClear}
          >
            <IoClose size={16} />
          </button>
        </div>

        <div className="progress mb-1" style={{ height: 16 }}>
          <div
            className="progress-bar bg-success"
            style={{ width: `${progressPercentage}%`, fontSize: '0.75rem' }}
          >
            {Math.round(progressPercentage)}%
          </div>
        </div>

        <p className="text-center small text-muted mb-3">
          {formatAudioFileSize(file.size, 1000000)}
        </p>

        <div className="d-flex justify-content-center gap-2">
          {onSave && (
            <button className="btn btn-sm btn-primary" onClick={onSave}>
              <IoSave className="me-1" />
              Save to list
            </button>
          )}

          {onPlay && (
            <button className="btn btn-sm btn-primary" onClick={onPlay}>
              <IoPlay className="me-1" />
              Play now
            </button>
          )}
        </div>
      </div>
    );
};

export default SelectedFileControl;
